import React from 'react'
import { Box } from '@mui/material'
import { PartialShoesAction, ShoesState } from 'src/types'
import { SettingButtons } from 'src/Components/Domain/SettingButtons'
import { SettingTabs } from 'src/Components/Domain/SettingTabs'
import { ShoesBaseSetter } from './BaseSetter'
import { ShoesColorSetter } from './ColorSetter'
import { ShoesEmbroiderySetter } from './EmbroiderySetter'
import { ShoesSimulationConfirmDialog } from 'src/features/simulationConfirm/Components/ShoesSimulationConfirmDialog'

type Props = {
  state: ShoesState
  dispatch: React.Dispatch<PartialShoesAction>
}

export const ShoesSetters: React.FC<Props> = ({ state, dispatch }) => {
  const [selectedIndex, setSelectedIndex] = React.useState(0)
  const [isDialogOpen, setIsDialogOpen] = React.useState<boolean>(false)
  const handleDialogOpen = () => setIsDialogOpen(true)
  const handleDialogClose = () => setIsDialogOpen(false)
  return (
    <Box border={'solid 1px #3f51b5'}>
      <SettingTabs {...{ selectedIndex, setSelectedIndex }} />
      <ShoesBaseSetter {...{ state, selectedIndex, dispatch }} />
      <ShoesColorSetter {...{ state, selectedIndex, dispatch }} />
      <ShoesEmbroiderySetter {...{ selectedIndex, dispatch }} embroideries={state.embroideries} productNumber={state.baseModel.productNumber} />
      <SettingTabs {...{ selectedIndex, setSelectedIndex }} />
      <SettingButtons {...{ handleDialogOpen }} />
      <ShoesSimulationConfirmDialog {...{ state, isDialogOpen, handleDialogClose, dispatch }} />
    </Box>
  )
}
